import React, {useContext, useEffect, useRef, useState} from "react";
import { useTranslation } from 'react-i18next';
import styles from "../../styles/dashboard.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faArrowRight,
    faCalendar,
    faClipboard,
    faClock,
    faCog,
    faEdit,
    faLocationDot,
    faMapPin, faTrash, faVideo, faPlus
} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import GoogleMapReact from "google-map-react";
import axiosInstance from "../../AxiosInstance";
import Modal from "../modal/modal";
import {LogoInput, SelectInput, TextInput} from "../input/inputs";
import MyContext from "../../Context";
import {countAlertStates} from "../../utils/alertCounts";
import {VARIABLE_TYPE, getVariableType, getBooleanLabel} from "../utils";
import {HighAlert, LowAlert, MediumAlert} from "../alerts/alerts";
import {Label, Select} from "../ajonjolib/inputs/ajonjolinput";
import CameraViewer from "../camera_viewer/camera_viewer";
import CameraManager from "../camera_viewer/camera_manager";
import {getCameras, deleteCamera} from "../../services/cameraService";
import {Modal as BootStrapModal} from "react-bootstrap";

function PopupMap({location}) {
    const mapOptions = {
        center: {
            lat: 14.7273,
            lng: -17.4580
        },
        zoom: 17
    };

    const [mapCenter, setMapCenter] = useState(mapOptions.center);

    useEffect(() => {
        const locationWith4Decimals = {
            lat: parseFloat(parseFloat(location.lng).toFixed(4)),
            lng: parseFloat(parseFloat(location.lat).toFixed(4))
        }
        setMapCenter({
            lat: locationWith4Decimals.lat,
            lng: locationWith4Decimals.lng
        });
    }, [location]);

    const createMapOptions = () => {
        return {
            zoomControl: false, // Disable the default zoom control
            fullscreenControl: false, // Disable the default full screen control
        };
    };

    return (
        <div style={{width: '200px', height: '200px'}}>
            <GoogleMapReact
                style={{borderRadius: '6px'}}
                defaultCenter={mapOptions.center}
                center={mapCenter}
                defaultZoom={mapOptions.zoom}
                bootstrapURLKeys={{ key: 'AIzaSyAqEBaEszO4nf-OBb-VarsUZ_47bTwwc9g'}}
                yesIWantToUseGoogleMapApiInternals
                draggable={false}
                options={createMapOptions}
            >
                <div
                    lat={mapCenter.lat}
                    lng={mapCenter.lng}
                    style={{ width: '20px', height: '20px'}}
                    className={'d-flex justify-content-center align-items-center'}
                >
                    <FontAwesomeIcon icon={faMapPin} color={'#F00'} size={'xl'}/>
                </div>
            </GoogleMapReact>
        </div>
    )
}

function PopupPhoto({source}) {

    return (
        <div style={{width: '200px', height: '200px'}}>
            <img src={source} alt={'machine'} width={'200px'} height={'200px'}/>
        </div>
    )
}

function ActionPopupMachine({data, setShowDashboard, setShowSettings, setShowPopup, setForm, onOpenCameras}) {
    const { t } = useTranslation();

    const deleteMachine = () => {
        axiosInstance.delete(`device_user/${data.id}/`).then((response) => {
            window.location.reload();
        });
    }

    return (
        <div style={{width: '200px', height: 'auto'}}>
            <div className={styles.popupButton} onClick={() => {setShowPopup(false); setForm(prev => ({...prev, widget_name: data.name})); setShowDashboard(true)}}>
                <FontAwesomeIcon icon={faClipboard} color={'#64748B'} className={'me-2'}/>
                <div style={{color: '#334155'}}>Add to Dashboard</div>
            </div>
            <div className={styles.popupButton} onClick={() => {setShowPopup(false); setShowSettings(true)}}>
                <FontAwesomeIcon icon={faCog} color={'#64748B'} className={'me-2'}/>
                <div style={{color: '#334155'}}>Settings</div>
            </div>
            <div className={styles.popupButton} onClick={() => {setShowPopup(false); onOpenCameras();}}>
                <FontAwesomeIcon icon={faVideo} color={'#64748B'} className={'me-2'}/>
                <div style={{color: '#334155'}}>{t('camera.cameras')}</div>
            </div>
            <div className={styles.popupButton} onClick={() => deleteMachine()}>
                <FontAwesomeIcon icon={faTrash} color={'#f64a4a'} className={'me-2'}/>
                <div style={{color: '#f64a4a'}}>Delete</div>
            </div>
        </div>
    )
}

function ActionPopupDevice({data, setShowSettings, setShowDashboard, setShowPopup, setAlertFilter, setShowHistory, setForm, onOpenOfflineModal}) {

    const deleteDevice = () => {
        axiosInstance.delete(`device/${data.id}/`).then((response) => {
            window.location.reload();
        });
    }

    return (
        <div style={{width: '200px', height: 'auto'}}>
            <div className={styles.popupButton} onClick={() => {setShowPopup(false); setShowSettings(true);}}>
                <FontAwesomeIcon icon={faCog} color={'#64748B'} className={'me-2'}/>
                <div style={{color: '#334155'}}>Settings</div>
            </div>

            <div className={styles.popupButton} onClick={() => {setShowPopup(false); setShowHistory(true); setAlertFilter(0)}}>
                <FontAwesomeIcon icon={faCalendar} color={'#64748B'} className={'me-2'}/>
                <div style={{color: '#334155'}}>Alert History</div>
            </div>
            <div className={styles.popupButton} onClick={() => {setShowPopup(false); setForm(prev => ({...prev, widget_name: data.name})); setShowDashboard(true)}}>
                <FontAwesomeIcon icon={faClipboard} color={'#64748B'} className={'me-2'}/>
                <div style={{color: '#334155'}}>Add to Dashboard</div>
            </div>
            <div className={styles.popupButton} onClick={() => {setShowPopup(false); onOpenOfflineModal();}}>
                <FontAwesomeIcon icon={faClock} color={'#64748B'} className={'me-2'}/>
                <div style={{color: '#334155'}}>Max Offline Alert</div>
            </div>
            <div className={styles.popupButton} onClick={() => deleteDevice()}>
                <FontAwesomeIcon icon={faTrash} color={'#f64a4a'} className={'me-2'}/>
                <div style={{color: '#f64a4a'}}>Delete</div>
            </div>
        </div>
    )
}

export default function DeviceBox({notDevice, name, data, isDashboardItem, isDashboardEditMode, planRefreshRate = 900}) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showMap, setShowMap] = useState(false);
    const [showPhoto, setShowPhoto] = useState(false);
    const [mousePosition, setMousePosition] = useState({x: 0, y: 0});
    const [currentDeviceLocation, setCurrentDeviceLocation] = useState({lat: 0, lng: 0});
    const [showDashboard, setShowDashboard] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const [showSettings, setShowSettings] = useState(false);

    const [historyData, setHistoryData] = useState([]);
    const [alertFilter, setAlertFilter] = useState(0);
    const {dashboards, corporateGroup} = useContext(MyContext);
    const [form, setForm] = useState(data);
    const [hovered, setHovered] = useState(false);
    const [showBigPhoto, setShowBigPhoto] = useState(false);

    // Valor de una fila del historial de alertas. item.value es el valor
    // histórico crudo; las etiquetas viven en la variable asociada.
    const formatAlertValue = (item) => {
        const variableData = item.variable_data;
        if (getVariableType(variableData) !== VARIABLE_TYPE.BOOLEAN) return item.value;
        return getBooleanLabel(variableData, item.value).label;
    };
    const [machineOptions, setMachineOptions] = useState([]);

    const goto = (id) => {
        if(isDashboardItem && isDashboardEditMode) return;
        if(notDevice) {
            localStorage.setItem('device_user_id', id);
            localStorage.setItem('device_user', JSON.stringify(data));
            navigate('/devices')
        }
        else {
            localStorage.setItem('device', JSON.stringify(data));
            navigate('/variables')
        }
    }

    const handleLocationDotHover = (event, lat, long) => {
        setShowMap(true);
        setMousePosition({ x: event.clientX, y: event.clientY });
        setCurrentDeviceLocation({lat: lat, lng: long});
    };

    const addToDashboard = () => {
        let widgetType;
        if (notDevice) {
            widgetType = 0; // Machine
        } else if (data.type?.is_predictive_maintenance && data.type?.predictive_maintenance_system?.handler_key === 'bob_assistant') {
            widgetType = 4; // BOB
        } else {
            widgetType = 1; // Device
        }

        axiosInstance.post(`dashboard/${form.dashboard_id}/add_widget/`, {
            "name": form.widget_name,
            "key": data.id,
            "type": widgetType
        }).then((res) => {
            window.location.reload();
        })
    }

    useEffect(() => {
        let isMounted = true;
        if(showHistory) {
            const alertTypeMap = {1: 'high', 2: 'medium', 3: 'low'};
            const alertType = alertTypeMap[alertFilter];
            const url = `device_alert_history/?device_id=${data.id}${alertType ? `&alert_type=${alertType}` : ''}`;
            axiosInstance.get(url).then((res) => {
                if (isMounted) {
                    setHistoryData(res.data);
                }
            });
        }
        return () => {
            isMounted = false;
        };
    }, [showHistory, alertFilter]);

    const formatTimestamp = (timestamp) => {
        if(timestamp == null) return "-";
        return new Date(timestamp).toLocaleString('en-GB', {
            timeZone: corporateGroup?.timezone || 'UTC'
        });
    }

    const isOnline = () => {
        if (!data.last_message) return false;
        const threshold = (data.offline_threshold_seconds || planRefreshRate) * 1000;
        return (Date.now() - new Date(data.last_message).getTime()) < threshold;
    };

    const saveMachine = () => {
        let formData = new FormData();
        for(const key in form) {
            formData.append(key, form[key]);
        }

        if(notDevice) {
            axiosInstance.put('device_user/' + data.id + '/', formData).then((res) => {
                window.location.reload();
            });
        }
        else {
            axiosInstance.put('device/' + data.id + '/', formData).then((res) => {
                window.location.reload();
            });
        }
    }

    const [showCameras, setShowCameras] = useState(false);
    const [cameras, setCameras] = useState([]);
    const [showAddCamera, setShowAddCamera] = useState(false);
    const [editCamera, setEditCamera] = useState(null);

    // Assign camera picker
    const [showAssignPicker, setShowAssignPicker] = useState(false);
    const [allProjectCameras, setAllProjectCameras] = useState([]);
    const [assignLoading, setAssignLoading] = useState(false);
    const [cameraSearch, setCameraSearch] = useState('');

    const openCameras = async (e) => {
        if (e?.stopPropagation) e.stopPropagation();
        const list = await getCameras(data?.project?.id, data?.id);
        setCameras(list);
        setShowCameras(true);
    };

    const handleCameraDeleted = async (cameraId) => {
        await deleteCamera(cameraId);
        const list = await getCameras(data?.project?.id, data?.id);
        setCameras(list);
    };

    const handleCameraSaved = async (saved) => {
        const list = await getCameras(data?.project?.id, data?.id);
        setCameras(list);
    };

    const openAssignPicker = async () => {
        setCameraSearch('');
        setAssignLoading(true);
        setShowAssignPicker(true);
        try {
            const all = await getCameras(data?.project?.id);
            setAllProjectCameras(all);
        } finally {
            setAssignLoading(false);
        }
    };

    const handleToggleAssign = async (cam) => {
        const isAssigned = cam.device_user === data?.id;
        await axiosInstance.patch(`ip_camera/${cam.id}/`, {
            device_user: isAssigned ? null : data?.id,
        });
        const [all, mine] = await Promise.all([
            getCameras(data?.project?.id),
            getCameras(data?.project?.id, data?.id),
        ]);
        setAllProjectCameras(all);
        setCameras(mine);
    };

    const [, setTick] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setTick(t => t + 1), 30000);
        return () => clearInterval(id);
    }, []);

    const [showOfflineModal, setShowOfflineModal] = useState(false);
    const [offlineSeconds, setOfflineSeconds] = useState('');

    const openOfflineModal = () => {
        setOfflineSeconds(data.offline_threshold_seconds || '');
        setShowOfflineModal(true);
    };

    const saveOfflineThreshold = () => {
        const value = offlineSeconds !== '' ? parseInt(offlineSeconds) : null;
        axiosInstance.patch(`device/${data.id}/`, {offline_threshold_seconds: value})
            .then(() => {
                setShowOfflineModal(false);
                window.location.reload();
            });
    };

    const [showPopup, setShowPopup] = useState(false);
    const popupRef = useRef(null);

    const handleOutsideClick = (event) => {
        if (popupRef.current && !popupRef.current.contains(event.target)) {
            setShowPopup(false);
        }
    };

    useEffect(() => {
        if (showPopup) {
            document.addEventListener('mousedown', handleOutsideClick);
        } else {
            document.removeEventListener('mousedown', handleOutsideClick);
        }

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [showPopup]);

    useEffect(() => {
        let isMounted = true;
        setForm({
            ...form,
            device_user_id: [data?.device_user]
        });
        axiosInstance.get('machine/').then((response) => {
            if (isMounted) {
                setMachineOptions(response.data);
            }
        });
        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <div className={`${styles.variable_box} px-3 py-3`} style={{
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
        }} onContextMenu={(event) => {
            event.preventDefault();
            setMousePosition({ x: event.clientX, y: event.clientY });
            setShowPopup(true);
        }}>

            {showPopup && !isDashboardItem &&
                <div ref={popupRef} className={styles.popUpModule} style={{top: mousePosition.y + 10, left: mousePosition.x, position: 'absolute', zIndex: '100000'}}>
                    {notDevice ? <ActionPopupMachine setShowDashboard={setShowDashboard} setShowPopup={setShowPopup} setShowSettings={setShowSettings} setForm={setForm} data={data} onOpenCameras={openCameras}/>
                    :
                        <ActionPopupDevice setShowSettings={setShowSettings}
                                           setAlertFilter={setAlertFilter}
                                           setShowHistory={setShowHistory}
                                           setShowPopup={setShowPopup}
                                           setShowDashboard={setShowDashboard}
                                           setForm={setForm}
                                           data={data}
                                           onOpenOfflineModal={openOfflineModal}
                        />
                    }
                </div>
            }

            {notDevice ?
                <Modal name={t('resources.configureMachine')} show={showSettings} setter={setShowSettings} onClick={saveMachine} buttonName={t('common.save')}>
                    <LogoInput name={'Machine Logo'} current={data?.image?.image} internalName={'image_file'} form={form} setForm={setForm} hideName={true}/>
                    <TextInput name={'name'} internalName={'name'} form={form} setForm={setForm}/>
                </Modal>
                :
                <Modal name={t('resources.configureDevice')} show={showSettings} setter={setShowSettings} onClick={saveMachine} buttonName={t('common.save')}>
                    <LogoInput name={'Device Logo'} current={data?.image?.image} internalName={'image_file'} form={form} setForm={setForm} hideName={true}/>
                    <TextInput name={'name'} internalName={'name'} form={form} setForm={setForm}/>
                    <TextInput name={'Device EUI'} internalName={'sn'} form={form} setForm={setForm}/>
                    <Label>Machine</Label>
                    <Select options={machineOptions.map((x) => {
                        return {name: x.name, value: x.id}
                    })} value={form.device_user_id} onChange={(value) => {
                        setForm({
                            ...form,
                            device_user_id: value
                        })
                    }}/>
                </Modal>
            }

            <Modal name={t('dashboard.addWidget')} show={showDashboard} setter={setShowDashboard} onClick={addToDashboard} buttonName={t('common.add')}>
                <div className={'mb-3'}>
                    <SelectInput options={dashboards} name={'Dashboard'} internalName={'dashboard_id'} form={form} setForm={setForm}/>
                    <TextInput name={'Name'} internalName={'widget_name'} form={form} setForm={setForm}/>
                </div>
            </Modal>


            <Modal name={''} show={showBigPhoto} setter={setShowBigPhoto}>
                <div>
                    <img alt={'device'} src={data.image?.image} width={'100%'} height={'auto'}/>
                </div>
            </Modal>

            {/* Camera viewer modal (xl, direct bootstrap) */}
            <BootStrapModal show={showCameras} onHide={() => setShowCameras(false)} size="xl" centered>
                <BootStrapModal.Header closeButton>
                    <BootStrapModal.Title style={{ fontSize: 16 }}>
                        <FontAwesomeIcon icon={faVideo} className="me-2" />
                        {t('camera.camerasOf', {name: data.name})}
                    </BootStrapModal.Title>
                </BootStrapModal.Header>
                <BootStrapModal.Body>
                    <div className="d-flex justify-content-end mb-3">
                        <button className="btn btn-sm btn-outline-primary" onClick={openAssignPicker}>
                            <FontAwesomeIcon icon={faPlus} className="me-1" /> {t('camera.assignCamera')}
                        </button>
                    </div>
                    {cameras.length === 0 ? (
                        <div className="text-center text-muted py-5">
                            <FontAwesomeIcon icon={faVideo} size="2x" className="mb-2" /><br />
                            {t('camera.noCameras')}
                        </div>
                    ) : (
                        <div className="row g-3">
                            {cameras.map(cam => (
                                <div key={cam.id} className="col-12 col-md-6">
                                    {showCameras && !showAddCamera && <CameraViewer cameraId={cam.id} name={cam.name} camera={cam} />}
                                </div>
                            ))}
                        </div>
                    )}
                </BootStrapModal.Body>
            </BootStrapModal>

            {/* Assign camera picker */}
            <BootStrapModal show={showAssignPicker} onHide={() => setShowAssignPicker(false)} size="md" centered>
                <BootStrapModal.Header closeButton>
                    <BootStrapModal.Title style={{ fontSize: 16 }}>
                        <FontAwesomeIcon icon={faVideo} className="me-2" />
                        {t('camera.assignCamera')}
                    </BootStrapModal.Title>
                </BootStrapModal.Header>
                <BootStrapModal.Body>
                    {!assignLoading && (
                        <input
                            type="text"
                            className="form-control form-control-sm mb-3"
                            placeholder={t('common.search')}
                            value={cameraSearch}
                            onChange={e => setCameraSearch(e.target.value)}
                        />
                    )}
                    {assignLoading ? (
                        <div className="text-center text-muted py-4">{t('common.loading')}</div>
                    ) : allProjectCameras.length === 0 ? (
                        <div className="text-center text-muted py-4">{t('camera.noCamerasProject')}</div>
                    ) : (
                        <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                            {allProjectCameras.filter(cam => cam.name?.toLowerCase().includes(cameraSearch.toLowerCase())).map(cam => {
                                const isAssigned = cam.device_user === data?.id;
                                const isOtherDevice = cam.device_user != null && cam.device_user !== data?.id;
                                return (
                                    <div key={cam.id} className="d-flex align-items-center gap-2 py-2 border-bottom">
                                        <input
                                            type="checkbox"
                                            id={`assign-cam-${cam.id}`}
                                            checked={isAssigned}
                                            disabled={isOtherDevice}
                                            onChange={() => handleToggleAssign(cam)}
                                            style={{ width: 16, height: 16, cursor: isOtherDevice ? 'not-allowed' : 'pointer' }}
                                        />
                                        <label htmlFor={`assign-cam-${cam.id}`} style={{ flex: 1, cursor: isOtherDevice ? 'default' : 'pointer', marginBottom: 0 }}>
                                            <div style={{ fontWeight: 500, fontSize: 14 }}>{cam.name}</div>
                                            {cam.device_user_name && !isAssigned && (
                                                <div style={{ fontSize: 11, color: '#94A3B8' }}>{t('camera.assignedTo', { name: cam.device_user_name })}</div>
                                            )}
                                            {cam.onvif_host && <div style={{ fontSize: 11, color: '#94A3B8' }}>{cam.onvif_host}</div>}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </BootStrapModal.Body>
            </BootStrapModal>

            {showAddCamera && (
                <CameraManager
                    show={showAddCamera}
                    setter={setShowAddCamera}
                    camera={editCamera}
                    projectId={data?.project?.id}
                    deviceUserId={data?.id}
                    onSaved={handleCameraSaved}
                />
            )}

            <Modal name={'Alert History'} show={showHistory} setter={setShowHistory}>
                <div style={{overflowY: 'scroll', height: '400px', userSelect: 'none'}}>
                {historyData.map((item, index) => {
                    if (alertFilter === 0) {
                        return (
                            <div className={'mb-3 px-2 py-2 me-2'}
                                 style={{border: "solid #ccc 1px", borderRadius: '6px'}} key={index}>
                                <div>
                                    <div><b>{item.variable_data?.variable?.name}</b>: {formatAlertValue(item)}</div>
                                </div>
                                <div className={'d-flex align-items-center'}>
                                    <FontAwesomeIcon icon={faCalendar} className={'pe-2'}/>
                                    <div>{formatTimestamp(item.timestamp)}</div>
                                </div>
                                <div className={'d-flex'}>
                                    {item.high_count ? <HighAlert
                                        value={item.value}
                                        maxTolerated={item.variable_data?.medium_threshold}
                                        minTolerated={item.variable_data?.medium_threshold_2}
                                        isBoolean={item.variable_data?.bool_alert_value !== null && item.variable_data?.bool_alert_value !== undefined}
                                    /> : <></>}
                                    {item.medium_count ? <MediumAlert
                                        value={item.value}
                                        maxDesired={item.variable_data?.low_threshold}
                                        minDesired={item.variable_data?.low_threshold_2}
                                        isBoolean={item.variable_data?.bool_alert_value !== null && item.variable_data?.bool_alert_value !== undefined}
                                    /> : <></>}
                                    {item.low_count ? <LowAlert/> : <></>}
                                </div>
                            </div>
                        );
                    } else if (alertFilter === 1 && item.high_count) {
                        return (
                            <div className={'mb-3 px-2 py-2 me-2'}
                                 style={{border: "solid #ccc 1px", borderRadius: '6px'}} key={index}>
                                <div>
                                    <div><b>{item.variable_data?.variable?.name}</b>: {formatAlertValue(item)}</div>
                                </div>
                                <div className={'d-flex align-items-center'}>
                                    <FontAwesomeIcon icon={faCalendar} className={'pe-2'}/>
                                    <div>{formatTimestamp(item.timestamp)}</div>
                                </div>
                                <div className={'d-flex'}>
                                    {item.high_count ? <HighAlert
                                        value={item.value}
                                        maxTolerated={item.variable_data?.medium_threshold}
                                        minTolerated={item.variable_data?.medium_threshold_2}
                                        isBoolean={item.variable_data?.bool_alert_value !== null && item.variable_data?.bool_alert_value !== undefined}
                                    /> : <></>}
                                </div>
                            </div>
                        );
                    } else if (alertFilter === 2 && item.medium_count) {
                        return (
                            <div className={'mb-3 px-2 py-2 me-2'}
                                 style={{border: "solid #ccc 1px", borderRadius: '6px'}} key={index}>
                                <div>
                                    <div><b>{item.variable_data?.variable?.name}</b>: {formatAlertValue(item)}</div>
                                </div>
                                <div className={'d-flex align-items-center'}>
                                    <FontAwesomeIcon icon={faCalendar} className={'pe-2'}/>
                                    <div>{formatTimestamp(item.timestamp)}</div>
                                </div>
                                <div className={'d-flex'}>
                                    {item.medium_count ? <MediumAlert
                                        value={item.value}
                                        maxDesired={item.variable_data?.low_threshold}
                                        minDesired={item.variable_data?.low_threshold_2}
                                        isBoolean={item.variable_data?.bool_alert_value !== null && item.variable_data?.bool_alert_value !== undefined}
                                    /> : <></>}
                                </div>
                            </div>
                        );
                    } else if (alertFilter === 3 && item.low_count) {
                        return (
                            <div className={'mb-3 px-2 py-2 me-2'}
                                 style={{border: "solid #ccc 1px", borderRadius: '6px'}} key={index}>
                                <div>
                                    <div><b>{item.variable_data?.variable?.name}</b>: {formatAlertValue(item)}</div>
                                </div>
                                <div className={'d-flex align-items-center'}>
                                    <FontAwesomeIcon icon={faCalendar} className={'pe-2'}/>
                                    <div>{formatTimestamp(item.timestamp)}</div>
                                </div>
                                <div className={'d-flex'}>
                                    {item.low_count ? <LowAlert/> : <></>}
                                </div>
                            </div>
                        );
                    }
                })}
                </div>
            </Modal>

            <Modal name={'Max Offline Alert'} show={showOfflineModal} setter={setShowOfflineModal} onClick={saveOfflineThreshold} buttonName={t('common.save')}>
                <div className={'mb-3'}>
                    <label style={{color: '#4B5563', marginBottom: 4, display: 'block'}}>Threshold (seconds)</label>
                    <input
                        type={'number'} min={60} className={'form-control'}
                        placeholder={`Default: ${planRefreshRate}s`}
                        value={offlineSeconds}
                        onChange={e => setOfflineSeconds(e.target.value)}
                    />
                    <small className={'text-muted mt-1 d-block'}>
                        Plan default: {planRefreshRate}s — clear to reset to default
                    </small>
                </div>
            </Modal>

            {showMap &&
                <div  className={styles.popUpModule} style={{top: mousePosition.y + 20, left: mousePosition.x - 100, position: 'absolute', zIndex: '100000'}}>
                    <PopupMap location={currentDeviceLocation}/>
                </div>
            }

            {showPhoto &&
                <div className={styles.popUpModule} style={{top: mousePosition.y + 20, left: mousePosition.x - 100, position: 'absolute', zIndex: '100000'}}>
                    <PopupPhoto source={data.image?.image}/>
                </div>
            }

            <div className='d-flex flex-row justify-content-between align-items-center'>
                <div className={'d-flex align-items-center'}>
                    {!notDevice &&
                        <div>
                            <FontAwesomeIcon className={'me-1'} icon={faLocationDot} role={'button'} color={'#e8350f'} onMouseEnter={(event) => handleLocationDotHover(event, data.longitude, data.latitude)} onMouseLeave={() => setShowMap(false)}/>
                            {data.image?.image &&
                                <img alt={'device'} onClick={() => setShowBigPhoto(true)} src={data.image?.image} className={`${styles.deviceImage} me-2`} style={{cursor: "pointer"}}/>
                            }
                        </div>
                    }
                    <div className={`d-flex flex-row align-items-center ${notDevice && 'pb-1'}`}
                         style={{
                             height: `${notDevice ? '40px' : 'auto'}`,
                             cursor: 'pointer'
                        }} onClick={() => goto(data.id)}>
                        {notDevice && <img alt={'machine'} src={data.image?.image} className={`${styles.machineImage} me-2`} onMouseEnter={(event) => {setMousePosition({ x: event.clientX, y: event.clientY }); setShowPhoto(true)}} onMouseLeave={() => setShowPhoto(false)}/>}
                        <div onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)} className={`${styles.variable_name} ${styles.shrink_text}`} style={{
                            maxWidth: hovered ? '600px' : '200px'
                        }}>{name ? name : data.name}</div>
                    </div>
                </div>
                <div className={'d-flex align-items-center gap-2'}>
                    {notDevice && data.cameras_count > 0 && (
                        <div
                            role="button"
                            title={t('camera.viewCameras')}
                            onClick={openCameras}
                            style={{ position: 'relative', lineHeight: 1 }}
                        >
                            <FontAwesomeIcon icon={faVideo} color={'#64748B'} />
                            <span style={{
                                position: 'absolute', top: -5, right: -7,
                                background: '#e53935', color: '#fff',
                                borderRadius: '50%', fontSize: 9, width: 14, height: 14,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontWeight: 700
                            }}>
                                {data.cameras_count}
                            </span>
                        </div>
                    )}
                    <FontAwesomeIcon role='button' icon={faArrowRight} onClick={() => goto(data.id)}/>
                </div>
            </div>
            {!notDevice && (
                <div className={'d-flex align-items-center gap-1 mb-1'} style={{marginTop: 2}}>
                    <div style={{
                        width: 9, height: 9, borderRadius: '50%', flexShrink: 0,
                        backgroundColor: data.last_message ? (isOnline() ? '#22c55e' : '#ef4444') : '#cbd5e1'
                    }}/>
                    <span style={{fontSize: 11, color: '#64748B'}}>{formatTimestamp(data.last_message)}</span>
                </div>
            )}
            {/* El denominador tiene que ser el MISMO conjunto que el numerador:
                así "N active sensors" es literalmente high+medium+low. Las
                variables silenciadas o de texto plano no dibujan semáforo, así
                que tampoco se anuncian aquí. */}
            {!notDevice && <div className={`${styles.deviceSensors} mb-3`}> {countAlertStates(data.variables).total_count} active sensors</div>}
            <div className={`d-flex flex-row justify-content-between w-100 ${styles.severityRow}`} style={{marginTop: 'auto', flexShrink: 0}}>
                <div className={`${styles.variable_severity_container}`} style={{backgroundColor: "#FFE2E5"}} role={'button'} onClick={() => {
                    if(notDevice) return;
                    setAlertFilter(1);
                    setShowHistory(true)
                }}>
                    <div className="d-flex flex-column justify-content-center">
                        <div className={'d-flex justify-content-between'}>
                            <img src={'/alerts/high.png'} alt={'high'} className={styles.alertIcon}/>
                            <div className={styles.alertNumber}>{data.high_count}</div>
                        </div>
                        <div className={styles.variable_severity_text}>
                            Danger
                        </div>
                    </div>
                </div>
                <div className={`${styles.variable_severity_container}`} style={{backgroundColor: "#FFF4DE"}} role={'button'} onClick={() => {
                    if(notDevice) return;
                    setAlertFilter(2);
                    setShowHistory(true)
                }}>
                    <div className="d-flex flex-column justify-content-between">
                        <div className={'d-flex justify-content-between'}>
                            <img src={'/alerts/medium.png'} alt={'medium'} className={styles.alertIcon}/>
                            <div className={styles.alertNumber}>{data.medium_count}</div>
                        </div>
                        <div className={styles.variable_severity_text}>
                            Warning
                        </div>
                    </div>
                </div>
                <div className={styles.variable_severity_container} role={'button'} onClick={() => {
                    if(notDevice) return;
                    setAlertFilter(3);
                    setShowHistory(true)
                }}>
                    <div className="d-flex flex-column justify-content-between">
                        <div className={'d-flex justify-content-between'}>
                            <img src={'/alerts/low.png'} alt={'low'} className={styles.alertIcon}/>
                            <div className={styles.alertNumber}>{data.low_count}</div>
                        </div>
                        <div className={styles.variable_severity_text}>
                            OK
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}